import _cloneDeep from 'lodash/cloneDeep';

export default {
  merchantServiceOfferings: (state) => _cloneDeep(state.merchantServiceOfferings),
};
